export default "__VITE_ASSET__Dff64XV6__"